var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-salary",class:_vm.bem('basic-salary', { appearance: _vm.appearance }),domProps:{"textContent":_vm._s(_vm.salary.formatted)}})}
var staticRenderFns = []

export { render, staticRenderFns }